module.exports = __webpack_public_path__ + "static/media/country_cm.88a3085e.webp";